import React from 'react'
import RoomSystems from '../Components/RoomSystems'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import Buttons from '../Components/Buttons'
import { ROUTER } from '../router/constants'
import { useNavigate } from 'react-router-dom'

const Systems = () => {

    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

    const navigate = useNavigate()


    const handleConfirmSetting = () => {
        navigate(ROUTER.PAYMENT)
    }

    return (
        <div className='container' style={{ padding: isLargeScreen ? '60px 40px' : '30px 20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant={isLargeScreen ? 'h1' : 'h2'} align="center" color='black' sx={{ fontWeight: isLargeScreen ? 600 : 700, color: 'black', mb: '64px' }}>
                سیستم ها
            </Typography>
            <Box sx={{ mb: "64px" }}>
                <Typography
                    color={theme.palette.info.dark}
                    variant={isLargeScreen ? 'h5' : 'h6'}
                    align="center"
                    mb={'24px'}
                >
                    با لمس هر گزینه آن را فعال یا غیرفعال کنید
                </Typography>
                <RoomSystems />
            </Box>
            <Buttons backTitle={'بازگشت'} checkTitle={'ثبت'} backLink={ROUTER.SETTING} checkLink={''} onCheck={handleConfirmSetting} />
        </div>
    )
}

export default Systems
